import { createSelector } from '@reduxjs/toolkit';

export const selectArtists = (state) => state.followArtists;

export const selectFollowed = createSelector(
  [selectArtists],
  ({ followed }) => followed
);
